import React from 'react'
import './footer.css'
import {FaFacebookF} from 'react-icons/fa'
import {FiInstagram} from 'react-icons/fi'
import {IoLogoTwitter} from 'react-icons/io'

const Footer = () => {
  return (
    <footer>
      <a href='/#' className='footer__logo'>REIGNB</a>

      <ul className='permalinks'>
        <li><a href='/#'>Home</a></li>
        <li><a href='#about'>About</a></li>
        <li><a href='#expertise'>Expertise</a></li>
        <li><a href='#experience'>Skills</a></li>
        <li><a href='#services'>Services</a></li>
        <li><a href='#portifolio'>Portfolio</a></li>
        <li><a href='#testimonials'>Testimonials</a></li>
        <li><a href='#contact'>Contact</a></li>
      </ul>

      <div className='footer__socials'>
        <a href='https://www.facebook.com/callmae.charlyb?mibextid=ZbWKwL' target='_blank' rel="noreferrer"><FaFacebookF /></a>
        <a href='https://instagram.com/sadiqmyth?igshid=ZGUzMzM3NWJiOQ==' target='_blank' rel="noreferrer"><FiInstagram /></a>
        <a href='https://twitter.com' target='_blank' rel="noreferrer"><IoLogoTwitter /></a>
      </div>

      <div className='footer__copyright'>
        <small>&copy; 2024 Sadiq Haruna. All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
